/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Observable } from 'rxjs';

/**
 * API of pagination feature that can be consumed by third-party components.
 */
export abstract class PaginationApi {
  abstract readonly updated$: Observable<PaginationApi>;

  abstract set pageSize(n: number);
  abstract get pageSize(): number;

  abstract set currentPage(n: number);
  abstract get currentPage(): number;

  abstract get pageCount(): number;

  abstract get total(): number;

  abstract nextPage(): number;

  abstract previousPage(): number;
}
